import { NAME_KEY } from '@constants/fieldKeys'

export const filterSitesBySearch = (sites, search: string) =>
  sites.filter(site =>
    site.properties
      .find(property => property.key === NAME_KEY)
      ?.data?.value?.toLowerCase()
      .includes(search.toLowerCase()),
  )
